import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { tostSetting } from "../../../helpers/scripts";
import { ICurrencyRate, ISystemPercent } from "../../../helpers/types";
import {
    asyncGetCurrencyRateAction,
    asyncGetCurrencyRatesAction,
    asyncGetOnlineBankingPercentAction,
    asyncSaveAllCurrencyRatesAction,
    asyncUpdateOnlineBankingPercentAction,
} from "./currencyRatesAction";

interface currencyRatesState {
    rates: ICurrencyRate[];
    rate: ICurrencyRate | null;
    onlineBankingPercent: ISystemPercent | null;
    isLoading: boolean;
    error: string;
}

const initialState: currencyRatesState = {
    rates: [],
    rate: null,
    onlineBankingPercent: null,
    isLoading: false,
    error: "",
};

const currencyRatesSlice = createSlice({
    name: "currencyRatesSlice",
    initialState,
    reducers: {
        resetCurrencyRates(state) {
            state.rates = [];
            state.rate = null;
            state.onlineBankingPercent = null;
            state.isLoading = false;
            state.error = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(asyncGetCurrencyRatesAction.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(asyncGetCurrencyRatesAction.fulfilled, (state, action: PayloadAction<ICurrencyRate[]>) => {
                state.isLoading = false;
                state.error = "";
                state.rates = action.payload || [];
            })
            .addCase(asyncGetCurrencyRatesAction.rejected, (state, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(asyncGetCurrencyRateAction.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(asyncGetCurrencyRateAction.fulfilled, (state, action: PayloadAction<ICurrencyRate>) => {
                state.isLoading = false;
                state.error = "";
                state.rate = action.payload;
            })
            .addCase(asyncGetCurrencyRateAction.rejected, (state, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(asyncSaveAllCurrencyRatesAction.pending, (state) => {
                state.isLoading = true;
                state.error = "";
            })
            .addCase(asyncSaveAllCurrencyRatesAction.fulfilled, (state, action: PayloadAction<ICurrencyRate[]>) => {
                state.isLoading = false;
                state.error = "";
                state.rates = action.payload || [];
                toast.success("Валюты успешно сохранены", tostSetting);
            })
            .addCase(asyncSaveAllCurrencyRatesAction.rejected, (state, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload || "Не удалось сохранить валюты", tostSetting);
            })

            .addCase(asyncGetOnlineBankingPercentAction.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(asyncGetOnlineBankingPercentAction.fulfilled, (state, action: PayloadAction<ISystemPercent>) => {
                state.isLoading = false;
                state.error = "";
                state.onlineBankingPercent = action.payload;
            })
            .addCase(asyncGetOnlineBankingPercentAction.rejected, (state, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(asyncUpdateOnlineBankingPercentAction.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(asyncUpdateOnlineBankingPercentAction.fulfilled, (state, action: PayloadAction<ISystemPercent>) => {
                state.isLoading = false;
                state.error = "";
                state.onlineBankingPercent = action.payload;
                toast.success("Процент успешно обновлён", tostSetting);
            })
            .addCase(asyncUpdateOnlineBankingPercentAction.rejected, (state, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload || "Не удалось обновить процент", tostSetting);
            });
    },
});

export const { resetCurrencyRates } = currencyRatesSlice.actions;
export default currencyRatesSlice.reducer;